module.exports = __webpack_public_path__ + "img/powerpoint-1-on-1.1bd53df.svg";